<template>
  <div class="book-thumbnail" :class="{ 'book-thumbnail--safari': isSafari }">
    <BookCover
      class="book-thumbnail__cover"
      :doc="doc"
      :coverClass="coverClass"
      :fallbackCoverClass="fallbackCoverClass"
      :cacheBust="cacheBust"
    />
    <BookCover
      v-if="!isSafari"
      class="book-thumbnail__cover book-thumbnail__cover--background"
      :doc="doc"
      :cacheBust="cacheBust"
    />
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import BookCover from '@/app/components/book/card/BookCover.vue'
import { onMounted, ref } from 'vue'
import type { DocCoverProps } from '@/models/interfaces'
import { isSafari as _isSafari } from '@/helpers/userAgent'
import { platform } from '@/services/platform'

defineProps<{
  doc: DocCoverProps
  coverClass?: string
  fallbackCoverClass?: string
  cacheBust?: boolean
}>()

const isSafari = ref(false)

onMounted(async () => {
  isSafari.value = (await platform.isIOS()) || _isSafari()
})
</script>

<style lang="scss" scoped>
.book-thumbnail {
  position: relative;
  overflow: hidden;

  & > * {
    position: relative;
    z-index: 1;
  }

  &__cover--background {
    pointer-events: none !important;
    position: absolute !important;
    z-index: 0 !important;
    inset: 0;
    transform: scale(3);
    filter: blur(40px) saturate(1.3);
    opacity: 0.3;
  }
}

.book-thumbnail--safari {
  background: $c-black-5;
}

.night-mode .book-thumbnail {
  background: $c-dark-2;
  isolation: isolate;

  &__cover--background {
    filter: blur(50px) saturate(1.3);
    mix-blend-mode: color;
    opacity: 0.5;
  }
}

.night-mode .book-thumbnail--safari {
  background: $c-dark-2;
}
</style>
